// extracted by mini-css-extract-plugin
export default {"description":"about_description__qFQBk"};